export const ActionListOptionTypes = {
  SECTION_LIST: 'sectionList'
};